var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('ReconciliationBody',{attrs:{"totalCommissionEarned":_vm.totalCommissionEarned,"totalWalletBalance":_vm.totalWalletBalance,"processId":_vm.processId,"transactions":_vm.transactions,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }